import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteHotelExtra } from "../../api/apiHotelExtras";
import parseError from "../../utils/parseError";

const useDeleteHotelExtra = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteHotelExtraFn, isPending: isDelete } = useMutation({
        mutationFn: deleteHotelExtra,
        onSuccess: (res) => {
            const message = res?.message || "Hotel extra deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelExtras"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete hotel extra");
        },
    });

    return { deleteHotelExtra: deleteHotelExtraFn, isDelete };
};

export default useDeleteHotelExtra;
